module.exports = __webpack_public_path__ + "img/eye-of-perception.26dbbe2b.webp";